export const nullCheckWrap = <T, R>(exec: (...values: T[]) => R): (...values: T[]) => R => {
    return (...values: T[]) => {
        let res: R;
        if(values.every(x => x !== null && x !== undefined)){
            res = exec(...values);
        }
        return res;
    }
}